import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/http/api.service';
import { IOcbTag } from '@app/core/models';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable()
export class TagsService extends ApiService {

    private tagsUrl: string;

    private options = {
        headers: this.defaultHeaders,
        observe: 'body' as 'body',
    };

    constructor(httpClient: HttpClient) {
        super(httpClient);

        if (!environment.api.endpoint) {
            throw new Error('Could not initialize the "tags" service, the proxyPath configuration is invalid.');
        }

        this.tagsUrl = `${environment.api.endpoint}/tags`;
    }

    /**
     * Get the list of tags
     * @param environmentId Internal identifier of the environment
     */
    public getTags(environmentId?: string): Observable<IOcbTag[]> {

        let url = `${this.tagsUrl}`;

        if (environmentId) { url = `${url}?EnvironmentId=${environmentId}`; }

        return this.httpClient.get<IOcbTag[]>(url, this.options);
    }

}
